export default __webpack_public_path__ + "static/media/icn-curve1.a3909b12.svg";